module.exports = __webpack_public_path__ + "static/media/VideoExplainer.c57212a7.mp4";